export default {
  methods: {
    getArrayFromQuery(param, defaultValue = []) {
      const values = this.$route.query[param]
      if (!values) {
        return defaultValue
      } else if (Array.isArray(values)) {
        return values.map(v => v.split(','))
      } else {
        return values.split(',')
      }
    },
    arrayToQuery(value) {
      return value && value.length > 0 ? value.join(',') : undefined
    },
    refreshRoute(query, firstPage, paramsToRemove) {
      const newQuery = {
        ...this.$route.query,
        ...query,
      }

      if (firstPage) {
        newQuery['page'] = 1
      }

      if (paramsToRemove) {
        paramsToRemove.forEach(param => {
          newQuery[param] = undefined
        })
      }

      this.$router.push({ query: newQuery })
    },
  }
}
